interface LogoProps {
  size?: number;
  className?: string;
}

export function Logo({ size = 44, className = "" }: LogoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" fill="none" className={className}>
      <rect width="44" height="44" rx="14" fill="#111418" />
      {/* Crescent */}
      <path
        d="M24 9 C16 9 11 14.5 11 22 C11 29.5 16 35 24 35 C20 31.5 17.5 27 17.5 22 C17.5 17 20 12.5 24 9Z"
        fill="#E8A020"
      />
      {/* Stars */}
      <circle cx="29" cy="15" r="2.2" fill="#E8A020" />
      <circle cx="32" cy="21" r="1.4" fill="#F5B83D" opacity="0.7" />
      <circle cx="28" cy="26" r="1" fill="#E8A020" opacity="0.5" />
    </svg>
  );
}

export function CrescentBg({ size = 120, opacity = 0.06 }: { size?: number; opacity?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      style={{ opacity }}
      className="pointer-events-none"
    >
      <path
        d="M46 6 C27 6 14 18 14 36 C14 54 27 66 46 66 C36 59 30 48 30 36 C30 24 36 13 46 6Z"
        fill="currentColor"
      />
    </svg>
  );
}
